var map = {
	"./Home/Landing": [
		5148,
		148
	],
	"./Home/Landing.vue": [
		5148,
		148
	],
	"./Information/Aboutus": [
		8176,
		795
	],
	"./Information/Aboutus.vue": [
		8176,
		795
	],
	"./Information/Faq": [
		9660,
		660
	],
	"./Information/Faq.vue": [
		9660,
		660
	],
	"./Information/Howtouse": [
		1330,
		330
	],
	"./Information/Howtouse.vue": [
		1330,
		330
	],
	"./Information/Partnership": [
		5930,
		930
	],
	"./Information/Partnership.vue": [
		5930,
		930
	],
	"./Information/Policy": [
		5616,
		616
	],
	"./Information/Policy.vue": [
		5616,
		616
	],
	"./Information/Privacypolicy": [
		1426,
		426
	],
	"./Information/Privacypolicy.vue": [
		1426,
		426
	],
	"./Information/Privacyprotection": [
		1221,
		221
	],
	"./Information/Privacyprotection.vue": [
		1221,
		221
	],
	"./Information/Retailer": [
		4113,
		113
	],
	"./Information/Retailer.vue": [
		4113,
		113
	],
	"./Information/Tnc": [
		9658,
		658
	],
	"./Information/Tnc.vue": [
		9658,
		658
	],
	"./Order/Checkout": [
		9819,
		819
	],
	"./Order/Checkout.vue": [
		9819,
		819
	],
	"./Order/Status": [
		3306,
		306
	],
	"./Order/Status.vue": [
		3306,
		306
	],
	"./Order/components/Information": [
		9131,
		131
	],
	"./Order/components/Information.vue": [
		9131,
		131
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6294;
module.exports = webpackAsyncContext;